import { inject, Injectable } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';

@Injectable({
	providedIn: 'root',
})
export class AnalyticsService {
	// Services
	private readonly analytics = inject(Analytics);

	// Public methods
	public logEvent(
		eventName: string,
		eventParams?: Record<string, unknown>
	): void {
		logEvent(this.analytics, eventName, eventParams);
	}
}
